
import React from 'react';
import PageSEO from '@/components/seo/PageSEO';

const JobsSEO = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "itemListElement": [
      {
        "@type": "JobPosting",
        "position": 1,
        "title": "Sales Development Medewerker",
        "description": "Word Sales Development Medewerker bij De Afsprakenmaker in Gent. Telefonisch contact opnemen met bedrijven, afspraken inplannen en leads kwalificeren.",
        "hiringOrganization": {
          "@type": "Organization",
          "name": "De Afsprakenmaker",
          "sameAs": "https://afsprakenmaker.be"
        },
        "jobLocation": {
          "@type": "Place",
          "addressLocality": "Gent",
          "addressRegion": "Vlaanderen",
          "addressCountry": "BE"
        },
        "employmentType": "FULL_TIME",
        "validThrough": "2024-12-31"
      },
      {
        "@type": "JobPosting",
        "position": 2,
        "title": "Senior Sales Executive",
        "description": "Ervaren Senior Sales Executive voor uitdagende B2B projecten bij De Afsprakenmaker in Aalst. Complexe verkoopcycli en strategische klantrelaties.",
        "hiringOrganization": {
          "@type": "Organization",
          "name": "De Afsprakenmaker",
          "sameAs": "https://afsprakenmaker.be"
        },
        "jobLocation": {
          "@type": "Place",
          "addressLocality": "Aalst",
          "addressRegion": "Vlaanderen",
          "addressCountry": "BE"
        },
        "employmentType": "FULL_TIME",
        "validThrough": "2024-12-31"
      },
      {
        "@type": "JobPosting",
        "position": 3,
        "title": "Consultant en Ventes Sortantes",
        "description": "Consultant en Ventes Sortantes chez De Afsprakenmaker à Aalst. Prospection téléphonique, développement commercial et relation client.",
        "hiringOrganization": {
          "@type": "Organization",
          "name": "De Afsprakenmaker",
          "sameAs": "https://afsprakenmaker.be"
        },
        "jobLocation": {
          "@type": "Place",
          "addressLocality": "Aalst",
          "addressRegion": "Vlaanderen", 
          "addressCountry": "BE"
        },
        "employmentType": "FULL_TIME",
        "validThrough": "2024-12-31"
      }
    ]
  };

  return (
    <PageSEO
      title="Jobs bij De Afsprakenmaker | Sales Vacatures Gent & Aalst | Nederland & Frans"
      description="Zoek je een uitdagende sales job? De Afsprakenmaker heeft vacatures in Gent en Aalst: Sales Development, Senior Sales Executive en Consultant Ventes Sortantes. Solliciteer nu!"
      keywords="sales medewerker Gent Aalst, televerkoper B2B, sales development Vlaanderen, senior sales executive, consultant ventes sortantes, telemarketing jobs België, B2B sales vacature, sales consultant Oost-Vlaanderen"
      canonicalUrl="/jobs"
      ogTitle="Werk bij De Afsprakenmaker | Sales Vacatures Gent & Aalst"
      ogDescription="Sluit je aan bij ons sales team! Vacatures in Gent en Aalst voor Sales Development, Senior Sales en Consultant Ventes. 38-uren werkweek en vast contract."
      structuredData={structuredData}
    />
  );
};

export default JobsSEO;
